import { Dispatch, FC, SetStateAction, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '@mui/material';

import { ReactComponent as CommentIcon } from '@/assets/icons/CommentRounded.svg';
// import { ReactComponent as DeleteIcon } from '@/assets/icons/gallery-delete.svg';
import { ReactComponent as DownloadIcon } from '@/assets/icons/gallery-download.svg';
import { ReactComponent as ZoomInIcon } from '@/assets/icons/gallery-zoom-in.svg';
import { ReactComponent as ZoomOutIcon } from '@/assets/icons/gallery-zoom-out.svg';
import {
  Container,
  Divider,
  ToolbarBox,
  ToolbarButton,
  ToolbarButtonLabel,
} from '@/features/media/ui/FileManager/Toolbar.styles';

interface Props {
  activeFile: File | undefined;
  zoom: number;
  setZoom: Dispatch<SetStateAction<number>>;
  onClickComment: () => void;
}

const MIN_ZOOM = 2;
const MAX_ZOOM = 6;
const ZOOM_LEVEL = 0.5;

const Toolbar: FC<Props> = ({ activeFile, zoom, setZoom, onClickComment }) => {
  const { t } = useTranslation();

  const downloadFile = useCallback(async () => {
    if (activeFile) {
      const fileWithType = new File([activeFile], activeFile.name, {
        type: 'application/octet-stream',
      });
      const exportUrl = URL.createObjectURL(fileWithType);

      const link = document.createElement('a');
      link.href = exportUrl;
      link.download = activeFile.name;
      document.body.appendChild(link);
      link.click();

      URL.revokeObjectURL(exportUrl);
      document.body.removeChild(link);
    }
  }, [activeFile]);

  return (
    <Container>
      <ToolbarBox>
        <Tooltip title={t('View comments')} placement={'top'}>
          <span>
            <ToolbarButton onClick={onClickComment}>
              <CommentIcon />

              <ToolbarButtonLabel>{t('comment')}</ToolbarButtonLabel>
            </ToolbarButton>
          </span>
        </Tooltip>

        <Divider />

        <Tooltip title={t('Download file')} placement={'top'}>
          <span>
            <ToolbarButton onClick={downloadFile}>
              <DownloadIcon />
            </ToolbarButton>
          </span>
        </Tooltip>

        {/*<Tooltip title={t('Delete file')} placement={'top'}>*/}
        {/*<span>*/}
        {/*  <ToolbarButton onClick={downloadFile}>*/}
        {/*    <DeleteIcon />*/}
        {/*  </ToolbarButton>*/}
        {/*</span>*/}
        {/*</Tooltip>*/}

        <Divider />

        <Tooltip title={t('Zoom out')} placement={'top'}>
          <span>
            <ToolbarButton
              disabled={zoom === MIN_ZOOM}
              onClick={() => {
                if (zoom > MIN_ZOOM) {
                  setZoom((prev) => Math.round(prev / 0.25) * 0.25 - ZOOM_LEVEL);
                }
              }}
            >
              <ZoomOutIcon />
            </ToolbarButton>
          </span>
        </Tooltip>

        <ToolbarButtonLabel unselectable="on">{Math.round((zoom * 100) / 2)}%</ToolbarButtonLabel>

        <Tooltip title={t('Zoom in')} placement={'top'}>
          <span>
            <ToolbarButton
              disabled={zoom === MAX_ZOOM}
              onClick={() => {
                if (zoom < MAX_ZOOM) {
                  setZoom((prev) => Math.round(prev / 0.25) * 0.25 + ZOOM_LEVEL);
                }
              }}
            >
              <ZoomInIcon />
            </ToolbarButton>
          </span>
        </Tooltip>
      </ToolbarBox>
    </Container>
  );
};

export default Toolbar;
